import Cookie from 'js-cookie';

const videos = document.querySelectorAll('[data-youtube-id]');

function initYouTube() {
	/**
	 * Create an iframe for embedding a YouTube video
	 * @param {string} id - YouTube video ID
	 * @returns {HTMLIFrameElement} - The created iframe element
	 */
	function createIframe(id) {
		try {
			const iframe = document.createElement('iframe');
			iframe.width = 560;
			iframe.height = 315;
			iframe.src = `https://www.youtube.com/embed/${id}`;
			iframe.frameBorder = 0;
			iframe.allowFullscreen = true;
			iframe.loading = 'lazy'; // Add lazy loading for performance
			iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
			return iframe;
		} catch (error) {
			console.error('Error creating iframe:', error);
			return null;
		}
	}

	/**
	 * Initialize video only if cookies are accepted
	 * @param {string} id - YouTube video ID
	 * @param {HTMLElement} container - The container for the iframe
	 */
	function initIfCookiesAccepted(id, container) {
		try {
			const basicCookie = Cookie.get('si-cookie-settings-saved-basic');
			const basicSettings = Cookie.get('si-cookie-settings-basic');
			const categoryCookie = Cookie.get('si-cookie-settings-saved-categories');
			const categoryCookieSettings = Cookie.get('si-cookie-settings-categories');

			if (basicCookie === 'true' && basicSettings === 'full') {
				initVideo(id, container);
			} else if (categoryCookie === 'true') {
				const acceptedCookies = JSON.parse(categoryCookieSettings);
				if (acceptedCookies.marketing) {
					initVideo(id, container);
				}
			}
		} catch (error) {
			console.error('Error initializing video with cookies:', error);
		}
	}

	/**
	 * Replace the container content with the YouTube iframe
	 * @param {string} id - YouTube video ID
	 * @param {HTMLElement} container - The container for the iframe
	 */
	function initVideo(id, container) {
		const iframe = createIframe(id);
		if (iframe) {
			container.innerHTML = '';
			container.classList.add('is-playing');
			container.appendChild(iframe);
		}
	}

	/**
	 * Initialize all videos on the page based on cookie preferences
	 */
	function initAllVideos() {
		videos.forEach((video) => {
			const id = video.dataset.youtubeId;
			const container = video.parentNode;

			initIfCookiesAccepted(id, container);
		});
	}

	initAllVideos();
}

// Initialize YouTube videos if they are present on the page
if (videos.length) {
	initYouTube();
}

// Listen for the global cookie notice event and re-initialize videos when cookies are updated
document.addEventListener('si_cookie_notice_updated', () => {
	initYouTube();
});
